import { about } from "../../config";

// About
const About = () => {
    return (
        <div name='about' className='m-12 py-24 py-40 text-center'>
            <div className='p-7 text-2xl font-semibold'>
                About
            </div>
            <div className='my-4 flex justify-center'>
                <img
                    src={about.image.path}
                    alt={about.image.name}
                    width='200px'
                    className='rounded-full'
                />
            </div>
            <div>
                {about.description}
            </div>
        </div>
    );
}

export default About;